// extracted by mini-css-extract-plugin
module.exports = {"discountRateContainer":"DiscountRateWrapper_discountRateContainer__O0t9K","hightlightedDiscount":"DiscountRateWrapper_hightlightedDiscount__InFvL"};